import Grid from "@material-ui/core/Grid";
import { Box, Card, Checkbox, ListItem, Button, TextField, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../store/store";
import { addReel } from "../../../api/api";
import { getDataSetToRedux } from "../../../utility/getAffirmationAndCategory";

const ReelsAddComponent = () => {
    const dispatch = useDispatch();
    const categories = useSelector((appstate: AppState) => appstate.reelsCategories);
    const [reelsYoutubeId, setReelsYoutubeId] = useState("");
    const [selectedCategoryIds, setSelectedCategories] = useState<string[]>([]);

    const handleSubmit = async() => {
        if (reelsYoutubeId.length === 11) {
            // TODO: API REQUEST CREATE
            console.log(reelsYoutubeId);
            console.log(selectedCategoryIds);
            const response = await addReel(reelsYoutubeId, selectedCategoryIds);

            if (response.success) {
                alert("Success, after processing you'll receive an email.");
            } else {
                console.log(response.message);
                alert("Error")
            }
            handleClear();
        }
    }

    const handleClear = ()=>{
        setReelsYoutubeId("");
        setSelectedCategories([]);
    }

    return (
        <>
            <Grid container justifyContent="center">

                <Card style={{ width: 450, padding: 25, marginBottom: 50, }}>
                    <Typography variant="h5">
                        Add a New Reel
                    </Typography>
                    <Box height={15} />
                    <TextField
                        style={{ width: 200, marginLeft: 20, display: "flex", alignSelf: "flex-starts" }}
                        autoFocus
                        margin="dense"
                        label="Youtube Video Id"
                        type="email"
                        helperText="11 characters"
                        value={reelsYoutubeId}
                        onChange={(val) => {
                            if (val.target.value.length < 12) {
                                console.log(val.target.value.length)
                                setReelsYoutubeId(val.target.value)
                            }
                        }}

                    />
                    <Box height={15} />
                    {
                        categories.map((category) => {

                            let selected = false;
                            if (selectedCategoryIds.includes(category.id)) {
                                selected = true;
                            }


                            return (
                                <ListItem id={category.id}>
                                    <Checkbox
                                        checked={selected}
                                        onChange={() => {
                                            if (selectedCategoryIds.includes(category.id)) {
                                                const temp = [...selectedCategoryIds];
                                                const deleteIndex = temp.indexOf(category.id);
                                                temp.splice(deleteIndex, 1);
                                                setSelectedCategories(temp);
                                            } else {
                                                setSelectedCategories([...selectedCategoryIds, category.id])
                                            }
                                        }}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                    {category.name}
                                </ListItem>
                            )
                        })
                    }
                    <Button onClick={handleSubmit} color="primary">
                        Add
                    </Button>

                </Card>
            </Grid>

        </>
    );
}

export default ReelsAddComponent;